import { getAuthTokenAync } from "src/store/common";
import { Feedback, Meta } from "src/store/types";
import * as api from "./api";

interface FeedbackApiResponse {
  data: Feedback[];
  meta: Meta;
}

// fetch feedback list
export const fetchFeedbackList = async (data: {
  page: number;
  limit: number;
  search?: string;
}): Promise<FeedbackApiResponse> => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };

  if (data.search && data.search.trim()) {
    params.search = data.search.trim();
  }

  const token = getAuthTokenAync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/feedback`,
    params
  );
  return response;
};

// remove feedback
export const removeFeedback = (fid: string) => {
  const token = getAuthTokenAync();
  api.setHeaderAuthorization(token);
  return api.remove(`${process.env.REACT_APP_ADMIN_API_URL}/feedback/${fid}`);
};
